import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Alert, Button } from "reactstrap";

import {
  getHelpArticleUrl,
  HELP_ARTICLE_CATALOG_CATEGORIES,
} from "../../../helpers/helpCenter";

interface CatalogCategoryOnboardingBannerProps {
  canConfigure: boolean;
  onStartWizard: () => void;
  onDismiss: () => void;
}

const CatalogCategoryOnboardingBanner = ({
  canConfigure,
  onStartWizard,
  onDismiss,
}: CatalogCategoryOnboardingBannerProps) => {
  const { t, i18n } = useTranslation();
  const helpUrl = getHelpArticleUrl(HELP_ARTICLE_CATALOG_CATEGORIES, i18n.language);

  return (
    <Alert color="warning" className="mb-3 py-2">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
        <div className="d-flex align-items-start gap-2">
          <i className="ri-folder-3-line fs-5 mt-1" aria-hidden="true" />
          <div className="d-flex flex-column gap-1">
            <span>{t("studio.catalog.onboarding.bannerText")}</span>
            <a
              href={helpUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="small fw-medium"
            >
              <i className="ri-question-line align-bottom me-1" />
              {t("studio.catalog.onboarding.helpLink")}
            </a>
          </div>
        </div>
        <div className="d-flex flex-wrap gap-2">
          <Button color="link" size="sm" className="text-muted px-2" onClick={onDismiss}>
            {t("studio.catalog.onboarding.dismissBanner")}
          </Button>
          {canConfigure ? (
            <Button color="warning" size="sm" outline onClick={onStartWizard}>
              {t("studio.catalog.onboarding.startWizard")}
            </Button>
          ) : (
            <Button color="warning" size="sm" outline tag={Link} to="/settings/general">
              {t("studio.catalog.onboarding.openSettings")}
            </Button>
          )}
        </div>
      </div>
    </Alert>
  );
};

export default CatalogCategoryOnboardingBanner;
